/**
 * Constants for the link chart visualization
 */

export const CHART_CONFIG = {
  /** Fixed height for the graph area */
  GRAPH_HEIGHT: 600,
  /** Padding for fitView */
  FIT_VIEW_PADDING: 0.05,
  /** Minimum zoom level */
  MIN_ZOOM: 0.1,
  /** Maximum zoom level */
  MAX_ZOOM: 4,
} as const;

export const EDGE_STYLE = {
  stroke: "#757575",
  strokeWidth: 2,
} as const;

export const EDGE_LABEL_STYLE = {
  fill: "#1976d2",
  fontWeight: 600,
  fontSize: 11,
} as const;

export const EDGE_LABEL_BG_STYLE = {
  fill: "white",
  fillOpacity: 0.95,
} as const;

export const EDGE_LABEL_CONFIG = {
  padding: [8, 4] as [number, number],
  borderRadius: 4,
} as const;
